module.exports = __webpack_public_path__ + "17075bfe48c53ab17ee6ba092a360273.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/wasistgoldencity5.jpg
// module id = 916
// module chunks = 0